import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { AuthService } from '../services/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(
      private _authService: AuthService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available

        const token = this._authService.getToken(); // JSON.parse(localStorage.getItem('currentUser'));
        // console.log('Current token: ', token);

        if (token) {
          request = request.clone({
            setHeaders: { 
              Authorization: `Bearer ${token}`
            }
          });
        }

        return next.handle(request);
    }
}